import { useQuery } from "@apollo/client";

import { CofConfigId, type ResourceContainer, type ResourceKind } from "../../gql-generated/types";
import { orgChildResources } from "../api/queries/childResources";
import {
    type OrgChildResourcesQuery,
    type OrgChildResourcesQueryVariables,
} from "../api/queries/childResources.gql-generated";
import { type ApolloResult } from "../models";

import { useSelectedOrganizationContainer } from ".";

import { useFeatureGates } from "src/app/cof-feature-gates/hooks";

export interface OrgChildResourcesResult {
    resourceContainers: ResourceContainer[];
}

interface UseOrgChildResourcesProps {
    kind: ResourceKind;
    shouldSkip?: boolean;
    limit?: number;
    cursor?: string;
}
export const useOrgChildResources = ({
    kind,
    shouldSkip = false,
    limit = 1000,
    cursor = "",
}: UseOrgChildResourcesProps): ApolloResult<OrgChildResourcesResult> => {
    const { configs } = useFeatureGates();
    const isMyLensesOrgsV2Enabled = configs[CofConfigId.MyLensesOrgsV2].enabled;

    const { orgId } = useSelectedOrganizationContainer();

    const { loading, data, error } = useQuery<OrgChildResourcesQuery, OrgChildResourcesQueryVariables>(
        orgChildResources,
        {
            skip: shouldSkip || !orgId || !isMyLensesOrgsV2Enabled,
            variables: {
                limit: limit,
                cursor: cursor,
                kind,
                parentId: orgId ?? "",
            },
        },
    );

    const resourceContainers = [...(data?.childResources.resourceList ?? [])];

    return { resourceContainers, loading, error };
};
